<template>
  <div class="results-section">
    <div class="results-container">
      <!-- 成功标识 -->
      <div class="success-header">
        <div class="success-icon">
          <a-icon type="check" />
        </div>
        <h1 class="success-title">排队选择已结束</h1>
        <p class="success-subtitle">所有团队已完成选择，以下是最终分配结果</p>
      </div>

      <!-- 统计卡片 -->
      <div class="stats-grid">
        <div class="stat-card">
          <p class="stat-label">总需求</p>
          <p class="stat-number">{{ requirementPool.length }}</p>
        </div>
        <div class="stat-card">
          <p class="stat-label">已选择</p>
          <p class="stat-number">{{ selectedRequirementsCount }}</p>
        </div>
        <div class="stat-card">
          <p class="stat-label">流拍</p>
          <p class="stat-number">{{ failedRequirementsCount }}</p>
        </div>
        <div class="stat-card">
          <p class="stat-label">参与团队</p>
          <p class="stat-number">{{ teamList.length }}</p>
        </div>
      </div>

      <div class="results-details">
        <div class="results-title">
          <a-icon type="ordered-list" />
          详细分配结果
        </div>

        <!-- 成功选择的需求 -->
        <div v-if="selectedRequirementsCount > 0" class="result-category">
          <div class="category-title">
            <a-icon type="check-circle" style="color: #00b42a" />
            已选择需求 ({{ selectedRequirementsCount }})
          </div>
          <div class="result-list">
            <div v-for="requirement in selectedRequirements" :key="`selected-${requirement.source_id}`" class="result-item success">
              <div class="requirement-info">
                <span class="requirement-tag">BR-{{ requirement.source_id }}</span>
                <a class="requirement-name" :href="requirementLink(requirement)" target="_blank">{{ requirement.source_name || '需求标题' }}</a>
              </div>
              <div class="team-info">
                <a-icon type="team" />
                <span>{{ requirement.winner?.name || '未知团队' }}</span>
                <span v-if="requirement.selectionTime" class="selection-time">{{ formatSelectionTime(requirement.selectionTime) }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 流拍的需求 -->
        <div v-if="failedRequirementsCount > 0" class="result-category">
          <div class="category-title">
            <a-icon type="close-circle" style="color: #f53f3f" />
            流拍需求 ({{ failedRequirementsCount }})
          </div>
          <div class="result-list">
            <div v-for="requirement in failedRequirements" :key="`failed-${requirement.source_id}`" class="result-item failed">
              <div class="requirement-info">
                <span class="requirement-tag failed">BR-{{ requirement.source_id }}</span>
                <a class="requirement-name" :href="requirementLink(requirement)" target="_blank">{{ requirement.source_name || '需求标题' }}</a>
              </div>
              <div class="status-info">
                <a-icon type="minus-circle" />
                <span>无人选择</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
  name: 'ResultsSection',
  props: {
    venueInfo: {
      type: Object,
      default: () => ({})
    },
    requirementPool: {
      type: Array,
      default: () => []
    },
    teamList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    selectedRequirements() {
      return this.requirementPool.filter(req => req.status === 3);
    },
    failedRequirements() {
      return this.requirementPool.filter(req => req.status === 4);
    },
    selectedRequirementsCount() {
      return this.selectedRequirements.length;
    },
    failedRequirementsCount() {
      return this.failedRequirements.length;
    },

    requirementLink() {
      return record => {
        return this.$router.resolve({
          name: 'page:business:requirement:detail',
          params: {
            id: record.source_id
          }
        }).href;
      };
    }
  },
  methods: {
    formatSelectionTime(timeString) {
      return timeString ? dayjs(timeString).format('HH:mm:ss') : '';
    }
  }
};
</script>

<style lang="less" scoped>
.results-section {
  padding: 2rem;
  overflow-y: auto;
  background: #f9fafb;
  min-height: 100%;

  .results-container {
    max-width: 1200px;
    margin: 0 auto;
  }

  .success-header {
    text-align: center;
    margin-bottom: 3rem;

    .success-icon {
      width: 64px;
      height: 64px;
      border-radius: 50%;
      background: linear-gradient(135deg, #10b981, #059669);
      display: inline-flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 1rem;
      box-shadow: 0 8px 32px rgba(16, 185, 129, 0.3);

      .anticon {
        font-size: 32px;
        color: white;
      }
    }

    .success-title {
      font-size: 2rem;
      font-weight: 700;
      color: #1d2129;
      margin-bottom: 0.5rem;
    }

    .success-subtitle {
      color: #86909c;
      font-size: 1rem;
      margin: 0;
      max-width: 600px;
      margin-left: auto;
      margin-right: auto;
    }
  }

  .stats-grid {
    display: flex;
    justify-content: center;
    gap: 1.5rem;
    margin-bottom: 3rem;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
    flex-wrap: wrap;

    @media (max-width: 768px) {
      gap: 1rem;
    }

    .stat-card {
      width: 180px;
      background: #ffffff;
      border: 1px solid #f0f0f0;
      border-radius: 12px;
      padding: 0.5rem;
      text-align: center;
      transition: all 0.3s ease;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
      }

      .stat-label {
        color: #86909c;
        font-size: 0.875rem;
        font-weight: 500;
        margin: 0 0 0.5rem 0;
      }

      .stat-number {
        font-size: 2rem;
        font-weight: 700;
        background: linear-gradient(135deg, #4f46e5, #818cf8);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
        line-height: 1;
        margin: 0;
      }
    }
  }

  .results-details {
    .results-title {
      font-size: 1.1rem;
      font-weight: 600;
      color: #1d2129;
      margin-bottom: 1.5rem;
      display: flex;
      align-items: center;
      gap: 0.5rem;

      .anticon {
        color: #165dff;
      }
    }

    .result-category {
      margin-bottom: 2rem;

      &:last-child {
        margin-bottom: 0;
      }

      .category-title {
        font-size: 1rem;
        font-weight: 600;
        color: #1d2129;
        margin-bottom: 1rem;
        display: flex;
        align-items: center;
        gap: 0.5rem;
      }

      .result-list {
        display: flex;
        flex-direction: column;
        gap: 0.75rem;
      }

      .result-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 1rem;
        background: #ffffff;
        border: 1px solid #f2f3f5;
        border-radius: 8px;
        transition: all 0.3s ease;

        &:hover {
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
          transform: translateY(-1px);
        }

        &.success {
          border-left: 4px solid #00b42a;
        }

        &.failed {
          border-left: 4px solid #f53f3f;
        }

        .requirement-info {
          display: flex;
          align-items: center;
          gap: 0.75rem;

          .requirement-tag {
            font-size: 0.7rem;
            font-weight: 600;
            background: #165dff;
            color: white;
            padding: 0.2rem 0.6rem;
            border-radius: 999px;

            &.failed {
              background: #86909c;
            }
          }

          .requirement-name {
            font-weight: 600;
            color: #1d2129;
          }
        }

        .team-info,
        .status-info {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-size: 0.8rem;

          .selection-time {
            color: #86909c;
            margin-left: 0.5rem;
          }
        }

        .team-info {
          color: #00b42a;
        }

        .status-info {
          color: #86909c;
        }
      }
    }
  }
}
</style>
